import i18next from "i18next";

export const InputFieldRule = [{
    required: true,
    message: i18next.t("Fill in the field!")
}]